module.exports = __webpack_public_path__ + "static/assets/b6cdd205c5e99bf7808ab16e73817b74.png";